/**
 * Created by Ning Jiang on 2/7/2019.
 */

import {IGameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/IGameConfig";
import {IGameModuleConfig} from "@nolimitcity/slot-game/bin/core/gamemoduleconfig/IGameModuleConfig";
import {ReelPartCreator} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelPartCreator";
import {ReelSymbolStateCreator} from "@nolimitcity/slot-game/bin/core/reelsymbol/ReelSymbolStateCreator";
import {ISymbolSizeConfig, ISymbolStateConfig} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/core/resource/asset/Asset";
import {IFontsConfig} from "@nolimitcity/slot-game/bin/core/resource/font/IFontsConfig";
import {ISoundConfig} from "@nolimitcity/slot-game/bin/core/resource/sound/ISoundConfig";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {ParsedInitData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import {ServerDataParser} from "@nolimitcity/slot-game/bin/core/server/ServerDataParser";
import {HorribleHeroesFontConfig} from "./HorribleHeroesFontConfig";
import {HorribleHeroesGameAssets} from "./HorribleHeroesGameAssets";
import {HorribleHeroesGameConfig, IHorribleHeroesBigWinRatioConfig} from "./HorribleHeroesGameConfig";
import {HorribleHeroesSoundConfig} from "./HorribleHeroesSoundConfig";
import {HorribleHeroesServerDataParser} from "./server/HorribleHeroesServerDataParser";
import {HorribleHeroesParsedGameData} from "./server/data/HorribleHeroesParsedGameData";
import {HorribleHeroesParsedInitData} from "./server/data/HorribleHeroesParsedInitData";
import {HorribleHeroesReelSymbol} from "./symbols/HorribleHeroesReelSymbol";
import {HorribleHeroesReelSymbolStateCreator} from "./symbols/HorribleHeroesReelSymbolStateCreator";
import {GameRoundConfig} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundManager";
import {ReelStart} from "./gameround/reel/ReelStart";
import {SpinStart} from "./gameround/spin/SpinStart";
import {ReelStop} from "./gameround/reel/ReelStop";
import {HorribleHeroesNearWin} from "./gameround/nearWin/HorribleHeroesNearWin";
import {BigWinStep} from "./gameround/bigWin/BigWinStep";
import {NormalWin} from "./gameround/normalWin/NormalWin";
import {WinEnd} from "./gameround/winEnd/WinEnd";
import {GameModeTransitionController} from "@nolimitcity/slot-game/bin/timelinegameround/core/gamemode/GameModeTransitionController";
import {HorribleHeroesGameMode} from "./HorribleHeroesGameMode";
import {WinTextView} from "./views/WinTextView";
import {CountUpView} from "./views/CountUpView";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {HorribleHeroesTimelineReelsController} from "./reel/HorribleHeroesTimelineReelsController";
import {SpinReelController} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinReelController";
import {HorribleHeroesReelController} from "./reel/HorribleHeroesReelController";
import {HorribleHeroesReelBackgroundView} from "./reelBackground/HorribleHeroesReelBackgroundView";
import {HorribleHeroesBackground} from "./background/HorribleHeroesBackground";
import {BetWayWin} from "./gameround/betWayWin/betWayWin";
import {HorribleHeroesSpinReelPartAnimator} from "./reel/spinReel/HorribleHeroesSpinReelPartAnimator";
import {MysteryFeatureExpansion} from "./gameround/MysteryFeatureExpansion";
import {HorribleHeroesZeroBet} from "./gameround/zeroBet/HorribleHeroesZeroBet";
import {HorribleHeroesNearWinView} from "./views/HorribleHeroesNearWinView";
import {SoundManager} from "./resource/sound/SoundManager";
import {HorribleHeroesFreeSpinIntroView} from "./transitions/freeSpinIntro/HorribleHeroesFreeSpinIntroView";
import {HHFreeSpinOutroView} from "./transitions/freeSpinOutro/HHFreeSpinOutroView";
import {HorribleHerosScatterWildymbol} from "./symbols/HorribleHerosScatterWildymbol";
import {GameModeTransitionControllerWithView} from "@nolimitcity/slot-game/bin/timelinegameround/core/gamemode/GameModeTransitionControllerWithView";
import {ScatterPlusOneAnimation} from "./views/ScatterPlusOneAnimation";
import {SymbolWinAnimation} from "./symbols/SymbolWinAnimation";
import {HorribleHerosXSymbol} from "./symbols/HorribleHerosXSymbol";
import {HorribleHeroesGameRoundPresentation} from "./gameround/zeroBet/HorribleHeroesGameRoundPresentation";
import {ParticleAnimation} from "./views/particleAnimation";
import {HorribleHeroesSymbolL} from "./symbols/HorribleHeroesSymbolL";
import {HorribleHeroesSymbolM} from "./symbols/HorribleHeroesSymbolM";
import {StickyWildsView} from "./views/StickyWildsView";
import {HeroesIntroView} from "./views/HeroesIntroView";
import {HorribeHeroesReelAreaView} from "./reel/HorribeHeroesReelAreaView";
import {ReelAreaView} from "@nolimitcity/slot-game/bin/core/reel/reelarea/ReelAreaView";
import {HorribleHeroesSymbolMX} from "./symbols/HorribleHeroesSymbolMX";
import {InfectiousPresentation} from "./gameround/InfectiousPresentation";
import {HorribleHeroesStickyWildWin} from "./gameround/HorribleHeroesStickyWildWin";
import {ScatterCollectMeterView} from "./views/ScatterCollectMeterView";
import {HHRandomWild} from "./gameround/freeSpinLow/HHRandomWild/HHRandomWild";
import {HHRandomWildStop} from "./gameround/freeSpinLow/HHRandomWild/HHRandomWildStop";
import {HHRandomWildView} from "./views/HHRandomWildView";
import {MayhemModeIntroPresentation} from "./gameround/MayhemModeIntroPresentation";
import {MayhemModeIntroView} from "./views/MayhemModeIntroView";
import {HHScatterOverlayView} from "./views/HHScatterOverlayView";
import {LogoAnimations} from "./reelBackground/LogoAnimations";
import {TrailingWildSymbol} from "./symbols/TrailingWildSymbol";
import {HHRestoreDuringFreeSpinController} from "./transitions/HHRestoreDuringFreeSpin/HHRestoreDuringFreeSpinController";
import {HHRestoreDuringFreeSpinView} from "./transitions/HHRestoreDuringFreeSpin/HHRestoreDuringFreeSpinView";
import {FeaturePrice} from "./utils/FeaturePrice";
import {IndiSymWinHighLight} from "./gameround/IndiSymWinHighLight";

export class HorribleHeroesGameModuleConfig implements IGameModuleConfig {
    public static instance: HorribleHeroesGameModuleConfig = new HorribleHeroesGameModuleConfig();
    public static background: HorribleHeroesBackground;
    public static reelBackGroundView: HorribleHeroesReelBackgroundView;
    public static countUpView: CountUpView;
    public static winTextView: WinTextView;
    public static nearWinView: HorribleHeroesNearWinView;
    public static stickyWilds: StickyWildsView;
    public static mayHemModeIntro: MayhemModeIntroView;
    public static heroesIntro: HeroesIntroView;
    public static scatterPlusOne: ScatterPlusOneAnimation;
    public static scatterCollecMeter: ScatterCollectMeterView;
    public static symbolWinAnimation: SymbolWinAnimation;
    public static randomWildView: HHRandomWildView;
    public static scatterOverlayView: HHScatterOverlayView;
    public static logoAnimations: LogoAnimations;
    public static featurePrice: FeaturePrice;

    private static backgroundAnimation: ParticleAnimation;
    private static soundManager: SoundManager;
    GAME_CONFIG: IGameConfig = HorribleHeroesGameConfig.instance;
    SOUND_CONFIG: ISoundConfig = HorribleHeroesSoundConfig.instance;
    FONTS_CONFIG: IFontsConfig = HorribleHeroesFontConfig.FONTS;
    RESOURCES_CONFIG: IResourcesGroupConfig = HorribleHeroesGameAssets.RESOURCES_GROUPS;
    GAME_MODE_TRANSITIONS?: (() => GameModeTransitionController)[] = [
        () => {
            return new GameModeTransitionControllerWithView(
                HorribleHeroesGameMode.NORMAL,
                HorribleHeroesGameMode.FREESPIN_PICK,
                new HorribleHeroesFreeSpinIntroView(true)
            );
        },
        // this order matters for #370, always keep following 2 transitions before the next 2 transitions
        () => {
            return new HHRestoreDuringFreeSpinController(
                HorribleHeroesGameMode.FREESPIN_LOW,
                HorribleHeroesGameMode.FREESPIN_LOW,
                new HHRestoreDuringFreeSpinView(false)
            );
        },
        () => {
            return new HHRestoreDuringFreeSpinController(
                HorribleHeroesGameMode.FREESPIN_MID,
                HorribleHeroesGameMode.FREESPIN_MID,
                new HHRestoreDuringFreeSpinView(false)
            );
        },
        () => {
            return new GameModeTransitionController(
                HorribleHeroesGameMode.FREESPIN_PICK,
                HorribleHeroesGameMode.FREESPIN_LOW
            );
        },
        () => {
            return new GameModeTransitionController(
                HorribleHeroesGameMode.FREESPIN_PICK,
                HorribleHeroesGameMode.FREESPIN_MID
            );
        },
        () => {
            return new GameModeTransitionControllerWithView(
                HorribleHeroesGameMode.FREESPIN_LOW,
                HorribleHeroesGameMode.NORMAL,
                new HHFreeSpinOutroView()
            );
        },
        () => {
            return new GameModeTransitionControllerWithView(
                HorribleHeroesGameMode.FREESPIN_MID,
                HorribleHeroesGameMode.NORMAL,
                new HHFreeSpinOutroView()
            );
        },
    ];

    constructor() {
        if (HorribleHeroesGameModuleConfig.instance) {
            throw new Error("HorribleHeroesGameModuleConfig.constructor() - Instantiation failed: Singleton.");
        }
    }

    SERVER_PARSER: () => ServerDataParser = () => {
        return new HorribleHeroesServerDataParser();
    };

    // REEL_AREA_VIEW:() => ReelAreaView = () => new HorribleHeroesReelAreaView();

    PARSED_INIT_DATA: (data: any, dataParser: ServerDataParser) => ParsedInitData = (data, dataParser: ServerDataParser) => {
        return new HorribleHeroesParsedInitData(data, <HorribleHeroesServerDataParser>dataParser);
    }

    // REEL_VIEW?:(reelId:number) => PIXI.Container; // return type baseView? Default new PIXI.Sprite.

    PARSED_GAME_DATA: (data: any, dataParser: ServerDataParser) => ParsedGameData = (data, dataParser: ServerDataParser) => {
        return new HorribleHeroesParsedGameData(data, <HorribleHeroesServerDataParser>dataParser);
    }

    REEL_CONTROLLER: (reelId: number) => SpinReelController = reelId => new HorribleHeroesReelController(reelId);

    REEL_AREA_VIEW: () => ReelAreaView = () => {
        return new HorribeHeroesReelAreaView();
    };

    // REEL_PART_ANIMATOR?:(reelId:number) => SpinReelPartAnimator; // Default new SpinReelPartAnimator.
    REEL_PART_ANIMATOR: (reelId: number) => HorribleHeroesSpinReelPartAnimator = (reelId: number) => {
        return new HorribleHeroesSpinReelPartAnimator(reelId);
    };

    REEL_PART_CREATOR: () => ReelPartCreator = () => new ReelPartCreator(
        (symName: string, reelId: number, state?: ISymbolStateConfig, size?: ISymbolSizeConfig): HorribleHeroesReelSymbol => {
            if (symName.indexOf("L") > -1) {
                return new HorribleHeroesSymbolL(symName, reelId, state, size);
            }
            if (symName.indexOf("M") > -1 && symName.indexOf("MX") == -1) {
                return new HorribleHeroesSymbolM(symName, reelId, state, size);
            } else if (symName.indexOf("MX") > -1) {
                return new HorribleHeroesSymbolMX(symName, reelId, state, size);
            } else if (symName.indexOf("S") > -1 || symName.indexOf("W") > -1) {
                if (symName === "W") {
                    return new TrailingWildSymbol(symName, reelId, state);
                } else {
                    return new HorribleHerosScatterWildymbol(symName, reelId, state, size);
                }
            } else {
                if (symName.indexOf("X") != -1) {
                    return new HorribleHerosXSymbol(symName, reelId, state);
                }
                return new HorribleHeroesReelSymbol(symName, reelId, state, size);
            }
        });

    SYMBOL_STATE_CREATOR: () => ReelSymbolStateCreator = () => new HorribleHeroesReelSymbolStateCreator();

    REELS?: () => Reels = () => {
        return new HorribleHeroesTimelineReelsController();
    };

    GAME_FEATURE_CREATOR: () => void = () => {
        HorribleHeroesGameModuleConfig.soundManager = new SoundManager();
        HorribleHeroesGameModuleConfig.countUpView = new CountUpView();
        HorribleHeroesGameModuleConfig.winTextView = new WinTextView();
        HorribleHeroesGameModuleConfig.stickyWilds = new StickyWildsView();
        HorribleHeroesGameModuleConfig.mayHemModeIntro = new MayhemModeIntroView();
        HorribleHeroesGameModuleConfig.heroesIntro = new HeroesIntroView();
        HorribleHeroesGameModuleConfig.backgroundAnimation = new ParticleAnimation();
        HorribleHeroesGameModuleConfig.scatterPlusOne = new ScatterPlusOneAnimation();
        HorribleHeroesGameModuleConfig.scatterCollecMeter = new ScatterCollectMeterView();
        HorribleHeroesGameModuleConfig.logoAnimations = new LogoAnimations();
        HorribleHeroesGameModuleConfig.reelBackGroundView = new HorribleHeroesReelBackgroundView();
        HorribleHeroesGameModuleConfig.background = new HorribleHeroesBackground({
            layer: HorribleHeroesGameConfig.instance.LAYERS.BACKGROUND.name
        });

        HorribleHeroesGameModuleConfig.nearWinView = new HorribleHeroesNearWinView();
        HorribleHeroesGameModuleConfig.symbolWinAnimation = new SymbolWinAnimation();
        HorribleHeroesGameModuleConfig.randomWildView = new HHRandomWildView();

        HorribleHeroesGameModuleConfig.scatterOverlayView = new HHScatterOverlayView();

        HorribleHeroesGameModuleConfig.featurePrice = new FeaturePrice();
    };

    GAME_ROUND_CONFIG: () => GameRoundConfig = () => {
        return {
            NORMAL: {
                idle: [],
                idleLoop: [
                    new BetWayWin(false),
                ],
                starting: [
                    new SpinStart(),
                    new ReelStart(2, 0.05),
                    new ReelStart(1, 0),
                    new ReelStart(3, 0.05),
                    new ReelStart(0, 0),
                    new ReelStart(4, 0.05),
                    //Copied from Harlequin
                ],
                stoppable: [
                    new ReelStop(0),
                    new HorribleHeroesNearWin(1, 1),
                    new ReelStop(1),
                    new HorribleHeroesNearWin(2, 3),
                    new ReelStop(2),
                    new HorribleHeroesNearWin(3, 3),
                    new ReelStop(3),
                    new HorribleHeroesNearWin(4, 3),
                    new ReelStop(4)
                ],
                skippable: [
                    [
                        new MysteryFeatureExpansion()
                    ],
                    [
                        new InfectiousPresentation()
                    ],
                    [
                        new IndiSymWinHighLight(),
                        new BetWayWin(true),
                        new NormalWin(HorribleHeroesGameConfig.instance.WIN_RATIOS.normalWin[3]),
                    ],
                    [
                        new BigWinStep(<IHorribleHeroesBigWinRatioConfig>HorribleHeroesGameConfig.instance.WIN_RATIOS.normalWin[0], HorribleHeroesGameConfig.instance.WIN_RATIOS.bigWin[0])
                    ],

                    [
                        new BigWinStep(HorribleHeroesGameConfig.instance.WIN_RATIOS.bigWin[0], HorribleHeroesGameConfig.instance.WIN_RATIOS.bigWin[1])
                    ],
                    [
                        new BigWinStep(HorribleHeroesGameConfig.instance.WIN_RATIOS.bigWin[1], HorribleHeroesGameConfig.instance.WIN_RATIOS.bigWin[2])
                    ],
                    [
                        new BigWinStep(HorribleHeroesGameConfig.instance.WIN_RATIOS.bigWin[2], HorribleHeroesGameConfig.instance.WIN_RATIOS.bigWin[3])
                    ],
                    [
                        new BigWinStep(HorribleHeroesGameConfig.instance.WIN_RATIOS.bigWin[3], HorribleHeroesGameConfig.instance.WIN_RATIOS.bigWin[4])
                    ],
                    [
                        new WinEnd()
                    ]
                ]
            },
            FREESPIN_PICK: {
                idle: [
                    new HorribleHeroesZeroBet()
                ],
                idleLoop: [],
                starting: [
                    new HorribleHeroesGameRoundPresentation(true, false)
                ],
                stoppable: [
                    new HorribleHeroesGameRoundPresentation(false, true)
                ],
                skippable: [[
                    new HorribleHeroesGameRoundPresentation()
                ]]
            },
            FREESPIN_LOW: {
                idle: [
                    //#447
                    new MayhemModeIntroPresentation(),
                    new HorribleHeroesZeroBet()
                ],
                idleLoop: [],
                starting: [
                    new SpinStart(),
                    new HHRandomWild(), // #289
                    new ReelStart(2, 0.05),
                    new ReelStart(1, 0),
                    new ReelStart(3, 0.05),
                    new ReelStart(0, 0),
                    new ReelStart(4, 0.05),
                    //Copied from Harlequin
                ],
                stoppable: [
                    new HHRandomWildStop(), // #289
                    //#233
                    new ReelStop(0, 0.6),
                    new HorribleHeroesNearWin(1, 1),
                    new ReelStop(1, 0.6),
                    new HorribleHeroesNearWin(2, 1),
                    new ReelStop(2, 0.6),
                    new HorribleHeroesNearWin(3, 1),
                    new ReelStop(3, 0.6),
                    new HorribleHeroesNearWin(4, 3),
                    new ReelStop(4, 0.6)
                ],
                skippable: [
                    [
                        new MysteryFeatureExpansion()
                    ],
                    [
                        new InfectiousPresentation(),
                    ],
                    [
                        new IndiSymWinHighLight(),
                        new BetWayWin(true),
                        new NormalWin(HorribleHeroesGameConfig.instance.WIN_RATIOS.normalWin[3]),
                        new BigWinStep(<IHorribleHeroesBigWinRatioConfig>HorribleHeroesGameConfig.instance.WIN_RATIOS.normalWin[0], HorribleHeroesGameConfig.instance.WIN_RATIOS.bigWin[0])
                    ],
                    [
                        new BigWinStep(HorribleHeroesGameConfig.instance.WIN_RATIOS.bigWin[0], HorribleHeroesGameConfig.instance.WIN_RATIOS.bigWin[1])
                    ],
                    [
                        new BigWinStep(HorribleHeroesGameConfig.instance.WIN_RATIOS.bigWin[1], HorribleHeroesGameConfig.instance.WIN_RATIOS.bigWin[2])
                    ],
                    [
                        new BigWinStep(HorribleHeroesGameConfig.instance.WIN_RATIOS.bigWin[2], HorribleHeroesGameConfig.instance.WIN_RATIOS.bigWin[3])
                    ],
                    [
                        new BigWinStep(HorribleHeroesGameConfig.instance.WIN_RATIOS.bigWin[3], HorribleHeroesGameConfig.instance.WIN_RATIOS.bigWin[4])
                    ],
                    [
                        new WinEnd()
                    ]
                ]
            },
            FREESPIN_MID: {
                idle: [
                    //#447
                    new MayhemModeIntroPresentation(),
                    new HorribleHeroesZeroBet()
                ],
                idleLoop: [],
                starting: [
                    new SpinStart(),
                    new ReelStart(2, 0.05),
                    new ReelStart(1, 0),
                    new ReelStart(3, 0.05),
                    new ReelStart(0, 0),
                    new ReelStart(4, 0.05),
                    //Copied from Harlequin
                ],
                stoppable: [
                    new ReelStop(0, 0.6),
                    new HorribleHeroesNearWin(1, 1),
                    new ReelStop(1, 0.6),
                    new HorribleHeroesNearWin(2, 1),
                    new HorribleHeroesStickyWildWin(2),
                    new ReelStop(2, 0.6),
                    new HorribleHeroesNearWin(3, 1),
                    new HorribleHeroesStickyWildWin(3),
                    new ReelStop(3, 0.6),
                    new HorribleHeroesNearWin(4, 3),
                    new HorribleHeroesStickyWildWin(4),
                    new ReelStop(4, 0.6)
                ],
                skippable: [
                    [
                        new MysteryFeatureExpansion()
                    ],
                    [
                        new InfectiousPresentation(),
                    ],
                    [
                        new IndiSymWinHighLight(),
                        new BetWayWin(true),
                        new NormalWin(HorribleHeroesGameConfig.instance.WIN_RATIOS.normalWin[3]),
                        new BigWinStep(<IHorribleHeroesBigWinRatioConfig>HorribleHeroesGameConfig.instance.WIN_RATIOS.normalWin[0], HorribleHeroesGameConfig.instance.WIN_RATIOS.bigWin[0])
                    ],
                    [
                        new BigWinStep(HorribleHeroesGameConfig.instance.WIN_RATIOS.bigWin[0], HorribleHeroesGameConfig.instance.WIN_RATIOS.bigWin[1])
                    ],
                    [
                        new BigWinStep(HorribleHeroesGameConfig.instance.WIN_RATIOS.bigWin[1], HorribleHeroesGameConfig.instance.WIN_RATIOS.bigWin[2])
                    ],
                    [
                        new BigWinStep(HorribleHeroesGameConfig.instance.WIN_RATIOS.bigWin[2], HorribleHeroesGameConfig.instance.WIN_RATIOS.bigWin[3])
                    ],
                    [
                        new BigWinStep(HorribleHeroesGameConfig.instance.WIN_RATIOS.bigWin[3], HorribleHeroesGameConfig.instance.WIN_RATIOS.bigWin[4])
                    ],
                    [
                        new WinEnd()
                    ]
                ]
            }
        }
    };
}